import "./TimeSettings.scss";

export default function TimeSettings() {
  return (
    <section className="sales-layout__page time-settings">
      <h1>Einstellungen</h1>
      <p>Hier werden zukünftig die Zeiteinstellungen verwaltet.</p>
    </section>
  );
}
